module.exports = __webpack_public_path__ + "img/general-statistics-case-bg.ddd03471.jpg";